module.exports = __webpack_public_path__ + "static/media/tiger-transparent.ed72006c.png";